import { render, staticRenderFns } from "./ClaimsCorrespondence.vue?vue&type=template&id=440aefe7&scoped=true&"
import script from "./ClaimsCorrespondence.vue?vue&type=script&lang=js&"
export * from "./ClaimsCorrespondence.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsCorrespondence.vue?vue&type=style&index=0&id=440aefe7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440aefe7",
  null
  
)

export default component.exports